import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  FlorderDetail,
  FlowDetail, FlowPlanning,
  PackingMaterial,
} from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { FlorderEditDetailComponent } from 'app/modules/florder/florder-edit-detail/florder-edit-detail.component';
import { DetailFlowPanelStatus } from 'app/modules/florder/florder-edit-container/florder-edit.interface';
import { util } from 'app/core/util/util';
import { ScrollService } from 'app/core/services/scroll.service';

@Component({
  selector: 'app-flow-edit-detail',
  templateUrl: './flow-edit-detail.component.html',
  styleUrls: ['../../florder/florder-edit-detail/florder-edit-detail.component.scss'],
})
export class FlowEditDetailComponent extends FlorderEditDetailComponent<PackingMaterial, FlowDetail, FlowPlanning> implements OnChanges {
  @Input() flowDetail: FlowDetail;
  @Input() panelStatus: DetailFlowPanelStatus;
  @Input() sort: { sortField: string, sortAscending: boolean };
  @Input() maxAmountPopupIsShown: boolean;

  @Output() resetMaxAmountPopup = new EventEmitter();
  @Output() goBackClicked = new EventEmitter<void>();
  @Output() sortChange = new EventEmitter<{ sortField: string, sortAscending: boolean }>();

  disputeQuantitiesValid = true;

  get florderDetail(): FlowDetail {
    return this.flowDetail;
  }

  constructor(scrollService: ScrollService) {
    super(scrollService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.flowDetail && this.flowDetail) {
      this.validateDisputeQuantities();
    }
  }

  isValid(): boolean {
    return super.isValid() && this.disputeQuantitiesValid;
  }

  private validateDisputeQuantities() {
    if (this.panelStatus.validateDisputeQuantities) {
      const disputedMaterials = this.flowDetail.materials.filter(m => m.isEditable);
      const definitiveQuantitiesTotal = disputedMaterials.reduce((sum, material) => sum + util.toNumber(material.definitiveQuantity), 0);
      const disputeQuantitiesTotal = disputedMaterials.reduce((sum, material) => sum + util.toNumber(material.disputeQuantity), 0);
      this.disputeQuantitiesValid = definitiveQuantitiesTotal === disputeQuantitiesTotal;
    }
  }
}
